import {ItemDefinition} from "./utils";
import logo from "../../static/images/dawid_logo.svg";

const version = "0.0.1";
const name = "Data Management Plan";
const id = 'dmp0.0.1';

const project_info = new ItemDefinition({
    id: 'project_info',
    title: "Project information",
    fields: [
        {
            label: "Project title",
            type: "text",
        },
        {
            label: "Principal investigator",
            type: "text",
        },
        {
            label: "Institution",
            type: "text",
        },
        {
            label: "Project start date",
            type: "date",
        },
    ],
    chooseNext: function () {
        return project_summary;
    }
});

const project_summary = new ItemDefinition({
    id: 'project_summary',
    title: "Project description",
    fields: [
        {
            label: "Short summary of the project",
            explanation: "A few sentences describing the goals and scope of the project.",
            type: "textarea",
        },
        {
            label: "Does the project involve human subjects' data?",
            type: "yesno",
        },
    ],
    chooseNext: function (states) {
        const {values} = states[this.id];
        if (values[1] === 1) {
            return ethics_item;
        }
        return data_types;
    }
});

const ethics_item = new ItemDefinition({
    id: 'ethics_item',
    title: "Ethics & consent",
    fields: [
        {
            label: "Has ethics approval been obtained?",
            type: "radio",
            options: [
                {"key": "y", "text": "Yes", value: "yes"},
                {"key": "p", "text": "Pending", value: "pending"},
                {"key": "n", "text": "Not required", value: "no"},
            ],
        },
        {
            label: "Reference number (if applicable)",
            type: "text",
        },
    ],
    chooseNext: function () {
        return data_types;
    }
});

const data_types = new ItemDefinition({
    id: 'data_types',
    title: "Data to be collected",
    fields: [
        {
            label: "Primary type of data",
            type: "dropdown",
            options: [
                {"key": "0", "text": "Experimental measurements", value: 0},
                {"key": "1", "text": "Survey / questionnaire", value: 1},
                {"key": "2", "text": "Observational", value: 2},
                {"key": "3", "text": "Simulation / computational", value: 3},
                {"key": "4", "text": "Other", value: 4},
            ],
        },
        {
            label: "How many distinct datasets will the project produce?",
            type: "number",
        },
    ],
    chooseNext: function () {
        return dataset_name;
    }
});

const dataset_name = new ItemDefinition({
    id: 'dataset_name',
    loopName: "datasets_loop",
    title: "Dataset details",
    fields: [
        {
            label: "Name of the dataset",
            type: "text",
        },
        {
            label: "File format(s)",
            explanation: "e.g. CSV, FASTQ, NIfTI, …",
            type: "text",
        },
        {
            label: "Estimated size",
            type: "dropdown",
            options: [
                {"key": "0", "text": "Less than 1 GB", value: 0},
                {"key": "1", "text": "1 GB – 100 GB", value: 1},
                {"key": "2", "text": "100 GB – 1 TB", value: 2},
                {"key": "3", "text": "More than 1 TB", value: 3},
            ],
        },
    ],
    chooseNext: function () {
        return dataset_sensitivity;
    }
});

const dataset_sensitivity = new ItemDefinition({
    id: 'dataset_sensitivity',
    loopName: "datasets_loop",
    title: "Dataset sensitivity",
    fields: [
        {
            label: "Does this dataset contain personal or sensitive information?",
            type: "yesno",
        },
        {
            label: "Will this dataset be shared openly?",
            type: "radio",
            options: [
                {"key": "open", "text": "Open access", value: "open"},
                {"key": "restricted", "text": "Restricted (on request)", value: "restricted"},
                {"key": "closed", "text": "Closed", value: "closed"},
            ],
        },
    ],
    chooseNext: function (states, globals, loops) {
        const loopIndex = this.getLoopIndex(loops);
        const numberOfDatasets = states[data_types.id].values[1];
        if (loopIndex >= numberOfDatasets) {
            return storage_item;
        }
        return this.nextLoopIteration(loops);
    }
});

const storage_item = new ItemDefinition({
    id: 'storage_item',
    title: "Storage & backup",
    fields: [
        {
            label: "Where will the active data be stored?",
            type: "dropdown",
            options: [
                {"key": "0", "text": "Institutional server", value: 0},
                {"key": "1", "text": "Cloud provider", value: 1},
                {"key": "2", "text": "External hard drive / local", value: 2},
                {"key": "3", "text": "National research infrastructure", value: 3},
            ],
        },
        {
            label: "Backup frequency",
            type: "radio",
            options: [
                {"key": "d", "text": "Daily", value: "daily"},
                {"key": "w", "text": "Weekly", value: "weekly"},
                {"key": "m", "text": "Monthly", value: "monthly"},
            ],
        },
    ],
    chooseNext: function () {
        return retention_item;
    }
});

const retention_item = new ItemDefinition({
    id: 'retention_item',
    title: "Preservation & retention",
    fields: [
        {
            label: "How long will the data be retained after the project ends?",
            type: "dropdown",
            options: [
                {"key": "0", "text": "Less than 5 years", value: 0},
                {"key": "1", "text": "5 – 10 years", value: 1},
                {"key": "2", "text": "More than 10 years", value: 2},
                {"key": "3", "text": "Indefinitely", value: 3},
            ],
        },
        {
            label: "Designated long-term repository (if any)",
            type: "text",
        },
    ],
    chooseNext: function () {
        return the_end;
    }
});

const the_end = new ItemDefinition({
    id: 'theEnd',
    title: "Plan complete",
    fields: [],
    chooseNext: function () {
        return the_end;
    }
});

const items = [
    project_info,
    project_summary,
    ethics_item,
    data_types,
    dataset_name,
    dataset_sensitivity,
    storage_item,
    retention_item,
    the_end,
];

const loopsDefinitions = {
    datasets_loop: {
        name: "Datasets",
        allowPreliminary: false,
        getIterationName: function (globals, loopState, loopIndex) {
            const iterationState = loopState && loopState[loopIndex - 1];
            const datasetName = iterationState?.[dataset_name.id]?.values?.[0];
            return datasetName ? datasetName : `Dataset ${loopIndex}`;
        },
        loopType: 'datasets',
        hasMoreIterations: function (states, globals, loops) {
            const numberOfDatasets = states[data_types.id]?.values?.[1];
            const loopIndex = loops["datasets_loop"].index;
            return Number.isInteger(numberOfDatasets) && loopIndex < numberOfDatasets;
        }
    }
};

const flow = {id, items, name, version, logo, disclaimerText: "", loopsDefinitions, outputLabel: "data management plan"};
export default flow;
